import { ShopifyStoreConnection, VenueGetShopifyStoreConnectFilter } from '../../graphql/API';
import { venueGetShopifyStoreConnection } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueGetShopifyStoreConnectionApi = async (
  filter: VenueGetShopifyStoreConnectFilter,
): Promise<ShopifyStoreConnection> => {
  const result = await executeGql(venueGetShopifyStoreConnection, { filter });
  return processGqlResult('venueGetShopifyStoreConnection', result);
};
